import { render, staticRenderFns } from "./StuSelectClass.vue?vue&type=template&id=239ae38f&"
import script from "./stuselectclass.js?vue&type=script&lang=js&"
export * from "./stuselectclass.js?vue&type=script&lang=js&"
import style0 from "./StuSelectClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports